import React, { useState, useEffect } from 'react';
import {
    Row, Col, Form, Label, Input, Card, CardBody,
    Container, Button, FormFeedback
} from "reactstrap";
import { toast } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import MyTagInput from './myTagInput';
import "./CustomCheckbox.css";

const MaterialsCreate = () => {
    const [subtypes, setSubtypes] = useState([]);
    const [title, setTitle] = useState('');
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [loading, setloading] = useState(false);

    const navigate = useNavigate();

    const [validation, setValidation] = useState({
        title: null,
        subtypes: null,
        image: null,
    });

    const [checkboxes, setCheckboxes] = useState({
        is_floor_pickup: false,
    });

    const handleCheckboxChange = (key) => {
        setCheckboxes((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);

            const previewUrl = URL.createObjectURL(file);
            setImagePreview(previewUrl);
        } else {
            setImageFile(null);
            setImagePreview(null);
        }
    };

    const validateFields = () => {
        let isValid = true;
        const newValidation = {};

        newValidation.title = title.trim() !== '';
        newValidation.subtypes = subtypes.length >= 1;
        newValidation.image = imageFile !== null;

        setValidation(newValidation);

        Object.values(newValidation).forEach(v => {
            if (v !== true) isValid = false;
        });

        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateFields()) return;

        setloading(true);

        const formData = new FormData();
        formData.append('title', title);
        formData.append('sub_types', JSON.stringify(subtypes));
        formData.append('is_floor_pickup', checkboxes.is_floor_pickup);
        if (imageFile) formData.append('image', imageFile);

        try {
            const token = localStorage.getItem("authToken");
            const response = await fetch(`${process.env.REACT_APP_WEB_APP_URL}/api/web/materials/create`, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: formData,
            });

            const data = await response.json();

            if (response.status === 200) {
                toast.success('Material created successfully', { autoClose: 3000 });
                setloading(false);
                navigate(`/materials`);
            } else if (response.status === 422) {
                if (data?.errors) {
                    setloading(false);
                    Object.values(data.errors).forEach((errorArr) => {
                        errorArr.forEach((errMsg) => {
                            toast.error(errMsg, { autoClose: 3000 });
                        });
                    });
                } else {
                    setloading(false);
                    toast.error(data?.message || 'Validation failed', { autoClose: 3000 });
                }
            } else {
                setloading(false);
                toast.error(data?.message || `Error: ${response.statusText}`, { autoClose: 3000 });
            }
        } catch (err) {
            setloading(false);
            console.log(err);
            toast.error("Failed to create material", { autoClose: 3000 });
        }
    };

    document.title = "Add Material | Moeen";

    return (
        <div className="page-content">
            <Container fluid={true}>
                <Breadcrumbs maintitle="Home" title="Materials" breadcrumbItem='Add Material' />

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody>
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md="6">
                                            {/* Title */}
                                            <div className="mb-3">
                                                <Label>Material Name</Label>
                                                <Input
                                                    type="text"
                                                    placeholder="Enter material name"
                                                    value={title}
                                                    onChange={e => setTitle(e.target.value)}
                                                    valid={validation["title"] === true}
                                                    invalid={validation["title"] !== true && validation["title"] !== null}
                                                />
                                                <FormFeedback tooltip>Material Name is required.</FormFeedback>
                                            </div>
                                        </Col>

                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label>Sub Types</Label>
                                                <MyTagInput
                                                    value={subtypes}
                                                    onChange={setSubtypes}
                                                    valid={validation["subtypes"] === true}
                                                    invalid={validation["subtypes"] === false}
                                                />
                                                <FormFeedback tooltip>
                                                    Please add at least one subtype.
                                                </FormFeedback>
                                            </div>
                                        </Col>
                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label>Material Image</Label>
                                                <Input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={handleImageChange}
                                                    invalid={validation.image === false}
                                                />
                                                <FormFeedback tooltip>Please upload an image.</FormFeedback>

                                                {imagePreview && (
                                                    <div style={{ marginTop: '10px' }}>
                                                        <img
                                                            src={imagePreview}
                                                            alt="Preview"
                                                            style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: 4, border: '1px solid #ddd' }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md="6">
                                            <div className="d-flex flex-wrap gap-2">
                                                {[
                                                    { label: "Is Floor Pickup", key: "is_floor_pickup" },
                                                ].map(({ label, key }) => (
                                                    <div
                                                        key={key}
                                                        className={`custom-box-checkbox ${checkboxes[key] ? "active" : ""
                                                            }`}
                                                        onClick={() => handleCheckboxChange(key)}
                                                    >
                                                        {label}
                                                    </div>
                                                ))}
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col className="text-end">
                                            <Button type="submit" color="primary" disabled={loading}>
                                                {loading ? (
                                                <>
                                                    <span
                                                    className="spinner-border spinner-border-sm me-2"
                                                    role="status"
                                                    aria-hidden="true"
                                                    ></span>
                                                </>
                                                ) : (
                                                "Submit"
                                                )}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default MaterialsCreate;
